/**
 * Tiny cookie helpers for the language cookie. The server package sets
 * `emp_lang` (not httpOnly) on POST /session-language; the selector reads it
 * to show the current language without a roundtrip, and writes it as a
 * fallback when the server call fails.
 */

export const LANGUAGE_COOKIE = 'emp_lang';

export const readCookie = name => {
  if (typeof document === 'undefined' || !document.cookie) return null;
  for (const part of document.cookie.split(';')) {
    const eq = part.indexOf('=');
    if (eq === -1) continue;
    if (part.slice(0, eq).trim() === name) {
      try {
        return decodeURIComponent(part.slice(eq + 1).trim());
      } catch (_) {
        return part.slice(eq + 1).trim();
      }
    }
  }
  return null;
};

export const writeCookie = (name, value, maxAgeSeconds = 365 * 24 * 60 * 60) => {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=/; samesite=lax`;
};

export const readLanguageCookie = () => readCookie(LANGUAGE_COOKIE);
export const writeLanguageCookie = language => writeCookie(LANGUAGE_COOKIE, language);
